/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTransactionsReport200ResponseInner } from './GetTransactionsReport200ResponseInner';
import {
    GetTransactionsReport200ResponseInnerFromJSON,
    GetTransactionsReport200ResponseInnerFromJSONTyped,
    GetTransactionsReport200ResponseInnerToJSON,
    GetTransactionsReport200ResponseInnerToJSONTyped,
} from './GetTransactionsReport200ResponseInner';

/**
 * 
 * @export
 * @interface GetPayoutReport200Response
 */
export interface GetPayoutReport200Response {
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    totalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    payoutAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    feeAmount: number;
    /**
     * 
     * @type {string}
     * @memberof GetPayoutReport200Response
     */
    locationId: string;
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    feePayoutAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    fixedFee: number;
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    percentageFee: number;
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    feeTax: number;
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    feeAmountWithTax: number;
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    originalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    refundedAmount: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPayoutReport200Response
     */
    isEmailed: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPayoutReport200Response
     */
    provider: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPayoutReport200Response
     */
    isTransferred: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPayoutReport200Response
     */
    transferDate: string;
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    commissionPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof GetPayoutReport200Response
     */
    cardPercentageFee: number;
    /**
     * 
     * @type {string}
     * @memberof GetPayoutReport200Response
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetPayoutReport200Response
     */
    legalEntityId: string;
    /**
     * 
     * @type {string}
     * @memberof GetPayoutReport200Response
     */
    creationTime: string;
    /**
     * 
     * @type {Array<GetTransactionsReport200ResponseInner>}
     * @memberof GetPayoutReport200Response
     */
    transactions: Array<GetTransactionsReport200ResponseInner>;
}

/**
 * Check if a given object implements the GetPayoutReport200Response interface.
 */
export function instanceOfGetPayoutReport200Response(value: object): value is GetPayoutReport200Response {
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('payoutAmount' in value) || value['payoutAmount'] === undefined) return false;
    if (!('feeAmount' in value) || value['feeAmount'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('feePayoutAmount' in value) || value['feePayoutAmount'] === undefined) return false;
    if (!('fixedFee' in value) || value['fixedFee'] === undefined) return false;
    if (!('percentageFee' in value) || value['percentageFee'] === undefined) return false;
    if (!('feeTax' in value) || value['feeTax'] === undefined) return false;
    if (!('feeAmountWithTax' in value) || value['feeAmountWithTax'] === undefined) return false;
    if (!('originalAmount' in value) || value['originalAmount'] === undefined) return false;
    if (!('refundedAmount' in value) || value['refundedAmount'] === undefined) return false;
    if (!('isEmailed' in value) || value['isEmailed'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('isTransferred' in value) || value['isTransferred'] === undefined) return false;
    if (!('transferDate' in value) || value['transferDate'] === undefined) return false;
    if (!('commissionPercentage' in value) || value['commissionPercentage'] === undefined) return false;
    if (!('cardPercentageFee' in value) || value['cardPercentageFee'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('transactions' in value) || value['transactions'] === undefined) return false;
    return true;
}

export function GetPayoutReport200ResponseFromJSON(json: any): GetPayoutReport200Response {
    return GetPayoutReport200ResponseFromJSONTyped(json, false);
}

export function GetPayoutReport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayoutReport200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'totalAmount': json['totalAmount'],
        'payoutAmount': json['payoutAmount'],
        'feeAmount': json['feeAmount'],
        'locationId': json['locationId'],
        'feePayoutAmount': json['feePayoutAmount'],
        'fixedFee': json['fixedFee'],
        'percentageFee': json['percentageFee'],
        'feeTax': json['feeTax'],
        'feeAmountWithTax': json['feeAmountWithTax'],
        'originalAmount': json['originalAmount'],
        'refundedAmount': json['refundedAmount'],
        'isEmailed': json['isEmailed'],
        'provider': json['provider'],
        'isTransferred': json['isTransferred'],
        'transferDate': json['transferDate'],
        'commissionPercentage': json['commissionPercentage'],
        'cardPercentageFee': json['cardPercentageFee'],
        'id': json['id'],
        'legalEntityId': json['legalEntityId'],
        'creationTime': json['creationTime'],
        'transactions': ((json['transactions'] as Array<any>).map(GetTransactionsReport200ResponseInnerFromJSON)),
    };
}

export function GetPayoutReport200ResponseToJSON(json: any): GetPayoutReport200Response {
    return GetPayoutReport200ResponseToJSONTyped(json, false);
}

export function GetPayoutReport200ResponseToJSONTyped(value?: GetPayoutReport200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalAmount': value['totalAmount'],
        'payoutAmount': value['payoutAmount'],
        'feeAmount': value['feeAmount'],
        'locationId': value['locationId'],
        'feePayoutAmount': value['feePayoutAmount'],
        'fixedFee': value['fixedFee'],
        'percentageFee': value['percentageFee'],
        'feeTax': value['feeTax'],
        'feeAmountWithTax': value['feeAmountWithTax'],
        'originalAmount': value['originalAmount'],
        'refundedAmount': value['refundedAmount'],
        'isEmailed': value['isEmailed'],
        'provider': value['provider'],
        'isTransferred': value['isTransferred'],
        'transferDate': value['transferDate'],
        'commissionPercentage': value['commissionPercentage'],
        'cardPercentageFee': value['cardPercentageFee'],
        'id': value['id'],
        'legalEntityId': value['legalEntityId'],
        'creationTime': value['creationTime'],
        'transactions': ((value['transactions'] as Array<any>).map(GetTransactionsReport200ResponseInnerToJSON)),
    };
}

